import React, { useState } from "react";
import styles from "./style.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import modalCheck from "../../../../../assets/modalCheck.svg";
import { ReactComponent as HidePwd } from "../../../../../assets/hide.svg";
import { ReactComponent as ShowPwd } from "../../../../../assets/show.svg";
import { ErrorMessage, Form, Formik } from "formik";
import { Button, Label } from "semantic-ui-react";
import { Alert } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import Modal from "../../../../../app/common/modals/Custom";
import { authSchema } from "../../../../../app/validation/validationSchema";
import { InputTemp } from "../../../../../app/common/form/Custom";
import { useStore } from "../../../../../app/stores/store";
import Loading from "../../../../../app/layout/Loading";
import responseCodes from "../../../../../app/common/hooks/helpers";

const VendorResetPassword = (props: any) => {
  const { inputField } = props;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [pwd, setPwd] = useState(false);
  const [cPwd, setCpwd] = useState(false);
  const [resInfo, setResInfo] = useState({
    status: false,
    message: "",
  });
  const clearError = () => {
    setResInfo({
      status: false,
      message: "",
    });
  };
  const { userStore, commonStore } = useStore();
  const { changePassword, loginStatus } = userStore;
  const initialValues = {
    newPassword: "",
    confirmPassword: "",
    email: "",
  };



  const handleResetPassword = async (values: any) => {
    changePassword({ ...values, email: inputField.email })
      .then((res) => {
        if (res?.responseCode === responseCodes.response_00) {
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
            navigate("/vendor/login");
          }, 3000);
        } else
          setResInfo({
            status: true,
            message: res.responseMessage,
          });
      })
      .catch((error) =>
        setResInfo({
          status: true,
          message: "Problem Completing Request",
        })
      );
  };

  return (
    <>
      <Modal openModal={open}>
        <h4>Password Reset Successful</h4>
        <img src={modalCheck} alt="" />
        <p>Redirecting to Log in ...</p>
      </Modal>
      {/* page */}
      <Formik
        initialValues={initialValues}
        onSubmit={handleResetPassword}
        validationSchema={authSchema.resetPassword}
      >
        {({ getFieldProps, touched, dirty, isValid, handleSubmit }) => (
          <Form onSubmit={handleSubmit} className={styles.container}>
            {loginStatus === "loading" && <Loading />}
            <h3>Reset Password?</h3>
            <h3>Enter new password and confirm it</h3>
            <div className={styles.input}>
              <div>
                <InputTemp
                  visibilityPadding
                  placeholder="New password"
                  inputType={pwd ? "text" : "password"}
                  {...getFieldProps("newPassword")}
                >
                  <i
                    className={styles.btnVisibility}
                    onClick={() => setPwd((state) => !state)}
                  >
                    {pwd ? <ShowPwd /> : <HidePwd />}
                  </i>
                </InputTemp>
                <div style={{ display: "flex", width: "100%" }}>
                  <ErrorMessage
                    name={"newPassword"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
              </div>
              <div>
                <InputTemp
                  visibilityPadding
                  placeholder="Confirm password"
                  inputType={cPwd ? "text" : "password"}
                  {...getFieldProps("confirmPassword")}
                >
                  <i
                    className={styles.btnVisibility}
                    onClick={() => setCpwd((state) => !state)}
                  >
                    {cPwd ? <ShowPwd /> : <HidePwd />}
                  </i>
                </InputTemp>
                <div style={{ display: "flex", width: "100%" }}>
                  <ErrorMessage
                    name={"confirmPassword"}
                    render={(error) => (
                      <Label basic color="red" content={error} />
                    )}
                  />
                </div>
              </div>
            </div>
            {resInfo.status &&
              touched &&
              dirty &&
              loginStatus !== "loading" && (
                <Alert variant="danger" onClose={clearError} dismissible>
                  {resInfo.message}
                </Alert>
              )}
            <Button
              positive
              className={styles.positive}
              variant="primary"
              type="submit"
              content="Reset Password"
              disabled={loginStatus === "loading" || !dirty || !isValid}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default observer(VendorResetPassword);
